var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e20fdbd4!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./comingSoon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/admin/adminPortal/comingSoon.vue
// module id = 454
// module chunks = 61